/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Filter_HiddenInputs */



/**
* | output |
* | --- |
* | "Hidden contacts" |
*
* @param {Team_Filter_HiddenInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_filter_hidden = /** @type {((inputs?: Team_Filter_HiddenInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Filter_HiddenInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verborgen contacten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contacts masqués")
	return /** @type {LocalizedString} */ ("Hidden contacts")
});